import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Location } from 'models/locations';

const propTypes = {
  selectedLocation: PropTypes.instanceOf(Location).isRequired,
  msa: PropTypes.string.isRequired,
};

const MonthlyPhoneNumber = ({
  selectedLocation,
  msa,
}) => {
  if (msa !== 'New York') { return null; }
  const { sellerId } = selectedLocation;
  let phoneNumber = null;
  switch (sellerId) {
    case 1024:
      phoneNumber = '646-762-1158';
      break;
    case 1390:
      phoneNumber = '646-759-9663';
      break;
    default:
      phoneNumber = '646-791-2684';
  }
  return (
    <p>
      <FormattedMessage
        id="checkout.monthly-phone-prompt"
        defaultMessage="Questions? Call "
      />
      <a href={`tel://${phoneNumber}`}>{phoneNumber}</a>
    </p>
  );
};

MonthlyPhoneNumber.propTypes = propTypes;
export default MonthlyPhoneNumber;
